import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Store } from '@ngrx/store';
import { EMPTY, Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import * as DebugActions from './debug.actions';

@Injectable()
export class DebugEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);

  loadDebugs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DebugActions.setDebug),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      concatMap(() => EMPTY as Observable<{ type: string }>),
    );
  });

  constructor() {
    const store = this.store;

    const w = window as any;

    console.log('started');

    w['enableVmspdbDebug'] = function () {
      store.dispatch(DebugActions.setDebug({ enabled: true }));
    };

    w['disableVmspdbDebug'] = function () {
      store.dispatch(DebugActions.setDebug({ enabled: false }));
    };
  }
}
